import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { QRCodeSVG } from "qrcode.react";
import { supabase } from "@/integrations/supabase/client";
import { useAuth } from "@/hooks/useAuth";
import { MobileShell } from "@/components/MobileShell";
import { BrandHeader } from "@/components/BrandHeader";
import { Button } from "@/components/ui/button";
import { Copy, Check, Bluetooth } from "lucide-react";
import { toast } from "sonner";
import { Link } from "react-router-dom";

const Receive = () => {
  const navigate = useNavigate();
  const { user } = useAuth();
  const [cashtag, setCashtag] = useState<string | null>(null);
  const [copied, setCopied] = useState(false);

  useEffect(() => {
    if (!user) return;
    supabase.from("profiles").select("cashtag").eq("user_id", user.id).maybeSingle()
      .then(({ data }) => setCashtag((data as any)?.cashtag ?? null));
  }, [user]);

  const payload = cashtag ? `cashisle:pay/${cashtag}` : "";

  const copy = async () => {
    if (!cashtag) return;
    await navigator.clipboard.writeText(`$${cashtag}`);
    setCopied(true);
    toast.success("Cashtag copied");
    setTimeout(() => setCopied(false), 1500);
  };

  return (
    <MobileShell>
      <BrandHeader onBack={() => navigate(-1)}>
        <h1 className="text-center mt-5 font-display text-2xl font-bold">Receive Money</h1>
      </BrandHeader>

      <div className="px-5 py-8 flex-1 flex flex-col items-center animate-fade-in-up">
        <p className="text-muted-foreground text-sm text-center mb-6">
          Share your cashtag or QR code to get paid instantly.
        </p>

        <div className="bg-background border border-border rounded-3xl p-6 shadow-card">
          {payload ? (
            <QRCodeSVG value={payload} size={220} level="M" fgColor="hsl(184 70% 24%)" />
          ) : (
            <div className="h-[220px] w-[220px] bg-muted rounded-xl animate-pulse" />
          )}
        </div>

        <div className="mt-7 text-center">
          <p className="text-xs uppercase tracking-wider text-muted-foreground">Your cashtag</p>
          <p className="font-display text-3xl font-extrabold text-primary mt-1">
            ${cashtag ?? "…"}
          </p>
        </div>

        <Button onClick={copy} variant="hero" size="xl" className="mt-7 w-full gap-2">
          {copied ? <Check className="h-5 w-5" /> : <Copy className="h-5 w-5" />}
          {copied ? "Copied" : "Copy cashtag"}
        </Button>

        <Link
          to="/receive-nearby"
          className="mt-3 w-full flex items-center justify-center gap-2 rounded-2xl border border-border bg-card px-5 h-14 font-medium hover:border-primary transition-colors"
        >
          <Bluetooth className="h-5 w-5 text-primary" />
          Receive via Bluetooth (offline)
        </Link>
      </div>

      <div className="safe-bottom" />
    </MobileShell>
  );
};

export default Receive;
